import { useCallback } from 'react';

import type { FeatureFlag } from 'api';
import { getCustomerCurrentUser, useGetFeatureFlags } from 'api';

export interface MfaSettings {
  totpEnabled: boolean;
  loading: boolean;
  hasVerifySetup: boolean;
  skipMfa: boolean;
  hasPhone: boolean;
}

export function useFetchMfaSettings() {
  const { refetch: refetchFeatureFlags } = useGetFeatureFlags<FeatureFlag>({
    query: {
      enabled: false,
      select: (resp) => resp.data
    }
  });

  const fetchMfaSettings = useCallback(async (): Promise<MfaSettings> => {
    const currentUser = await getCustomerCurrentUser();

    const user = currentUser?.user;

    return {
      totpEnabled: user?.has_verify_setup ?? false,
      loading: false,
      hasVerifySetup: Boolean(user?.has_verify_setup),
      skipMfa: Boolean(user?.skip_mfa),
      hasPhone: Boolean(user?.has_phone)
    };
  }, [refetchFeatureFlags]);

  return fetchMfaSettings;
}
